export default "__VITE_ASSET__e$kCunU___"